import apiClient from './apiClient.ts';

export interface UploadDefault {
  id?: number;
  name: string;
  video_title?: string;
  video_description?: string;
  tags?: string[];
  category?: string;
  category_name?: string;
  playlist_id?: string;
  playlist_name?: string;
  privacy_status?: string;
  license?: string;
  made_for_kids?: boolean;
  embeddable?: boolean;
  scheduled?: boolean;
  disable_watermark?: boolean;
}

export async function getUploadDefaults(): Promise<UploadDefault[]> {
  const response = await apiClient.get('/upload-defaults');
  return response.data.data;
}

export async function deleteUploadDefault(id: number): Promise<void> {
  await apiClient.delete(`/upload-defaults/${id}`);
}

export async function createUploadDefault(payload: UploadDefault): Promise<UploadDefault> {
  const response = await apiClient.post('/upload-defaults', payload);
  return response.data.data;
}

export async function updateUploadDefault(payload: UploadDefault): Promise<void> {
  await apiClient.put(`/upload-defaults/${payload.id}`, payload);
}
